import React from 'react';
import { Popup } from 'semantic-ui-react';
import CornerLabel from '../CornerLabel';
import EnjoyButton from '../EnjoyButton';
// import { log } from '#emyw/core-lib';  // eslint-disable-line

import './index.css';
const CertifiedLabel = props => {
  const {
    className,
    style,
    color
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: "posterCornerLabel".concat(className ? ' '.concat(className) : ''),
    style: style
  }, /*#__PURE__*/React.createElement(CornerLabel, {
    style: {
      color
    }
  }), /*#__PURE__*/React.createElement(Popup, {
    content: "Fully certified Enjoy features available!",
    trigger: /*#__PURE__*/React.createElement("div", {
      className: "posterCornerIcon"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(EnjoyButton, null))),
    position: "top center",
    size: "tiny"
  }));
};
CertifiedLabel.defaultProps = {
  className: null,
  style: {}
};
export default CertifiedLabel;